// extracted by mini-css-extract-plugin
module.exports = {"section":"styles_section__2Y0xc","title":"styles_title__9gg5A","upText":"styles_upText__UyTdN","bottomText":"styles_bottomText__XRWSc","aboutImg":"styles_aboutImg__3Wnr5"};